import { coreApi } from './api';

export default async function fetchMotivesData(accessToken) {
	const res = await coreApi.get('/motivo', {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	return res?.data;
}
